import { defineAction } from '~/prix'
import { z } from 'zod'
import materialDeliveryDocumentCreateAction from './materialDeliveryDocumentCreate.action.json' with { type: 'json' }
import { materialDeliveryDocumentObject } from '../materialDeliveryDocumentObject'

const materialDeliveryDocumentCreateDefinition = defineAction({
  ...materialDeliveryDocumentCreateAction,
  input: materialDeliveryDocumentObject
    .pick({
      id: true,
      materialDeliveryId: true,
      fileName: true,
      mimeType: true,
    })
    .extend({
      fileName: z.string().min(1, 'Nome do arquivo é obrigatório'),
    })
    .partial({ id: true, mimeType: true }),
  output: z.object({
    publicUrl: z.string().nullish(),
    uploadUrl: z.string().nullish(),
  }),
})

export default materialDeliveryDocumentCreateDefinition
